import LoadBatch from "../core/LoadBatch";
import F84Game from "../Game";
import LoaderScene from "../scenes/LoaderScene";
import { MapObjectProperty, Tileset } from "../utils/TiledMap";

export default class LoadBatches {
	static get Transition(): LoadBatch {
		const batch = F84Game.Instance.loadBatches.get("screen-transition");
		// const quality = F84Game.Instance.qualitySuffix;
		if (batch.assets.size == 0) {
			//
		}
		return batch;
	}

	//==========================// Global Assets //==========================//
	static get Global(): LoadBatch {
		const batch = F84Game.Instance.loadBatches.get("global");
		if (batch.assets.size == 0) {
			batch.addImages("./assets/images/temp/", {
				whiteCircle: "white-circle",
				whiteSquare: "white-square",
				yesBtn: "yes-btn",
				noBtn: "no-btn",
			});

			//used for level select and certificate

			batch.addImages("./assets/images/level-select/ag-lumi-lvl-", {
				header: "header",
				lock: "lock",
				lockOpen: "lock-open",
				lvlMedal: "medal",
				lvlNameBG: "namebase",
				lvlNumBG: "numberbase",
			});

			batch.addImages("./assets/images/game/ag-lumi-gp-", {
				scoreRays: "points-burstrays",
				pointParticle1: "points-particle-1",
				pointParticle2: "points-particle-2",
			});

			batch.addImages("./assets/images/level-select/", {
				unlockMeterBacker: "ag-lumi-ski-unlockmeter-backer",
				unlockMeterFull: "ag-lumi-ski-unlockmeter-full",
				unlockMeterEmpty: "ag-lumi-ski-unlockmeter-empty",
				unlockMeterStars: "ag-lumi-ski-unlockmeter-stars",
			});

			batch.addImages("./assets/images/level-select/ag-lumi-lvl-ski-icon-", {
				GreenCircleIcon: "beginner",
				BlueSquareIcon: "moderate",
				BlackDiamondIcon: "blackdi",
				DoubleBlackDiamondIcon: "dblblackdi",
				BackcountryIcon: "backwoods",
			});
			batch.addImages("./assets/images/level-select/ag-lumi-ski-lvl-", {
				lvlBacker: "backer",
				lvlBackerLocked: "backer-locked",
				lvlSelectBG: "bg",
				lvlCorinne: "corinne",
			});

			batch.addImages("./assets/images/ui/ag-lumi-ui-", {
				backBtn: "btn-back",
				scoreBG: "score",
				xBtn: "btn-x",
				checkBtn: "btn-check",
				soundBtnOff: "btn-sound-off",
				soundBtnOn: "btn-sound-on",
				popupBG: "popup-backer",
				popupSmallBG: "popup-smallbacker",
				popupHeader: "popup-header",
				popupSmallHeader: "popup-smallheader",
				popupTextBG: "popup-textback",
				popupOverlay: "popup-overlay",
			});
			batch.addImages("./assets/images/ui/", {
				closeBtn: "ag-lumi-btn-close",
			});

			batch.addImages("./assets/images/game-complete/", {
				pinkBacker: "ag-lumi-complete-cert-backer",
				largeBacker: "ag-lumi-ui-help-largebacker",
				completeDecoLeft: "ag-lumi-ski-complete-decoleft",
				completeDecoRight: "ag-lumi-ski-complete-decoright",
				completeImage: "ag-lumi-ski-complete-image",
				downloadBtn: "ag-lumi-complete-btn-download",
				downloadImage: "lumi-ski-gamecomplete-certif",
				lightBacker: "ag-lumi-complete-light-textbacker",
				darkBacker: "ag-lumi-complete-textback",
				completeHeader: "ag-lumi-complete-header",
				completeBG: "ag-lumi-complete-bg",
				completeStars: "ag-lumi-complete-stars",
			});

			batch.addImages("./assets/images/environment/ag-lumi-", {
				fallingSnow1: "fallingsnow1",
				fallingSnow2: "fallingsnow2",
				fallingSnow3: "fallingsnow3",
			});

			batch.addImages("./assets/images/ui/ag-lumi-ui-", {
				homeBtn: "btn-home",
			});

			batch.addImages("./assets/images/recap/ag-lumi-ui-", {
				popupMedal: "popup-medal",
			});

			batch.addSounds("./assets/audio/music/", {
				gameMusic: "ski-music_1",
			});
			batch.addSounds("./assets/audio/sfx/", {
				buttonPress: "ag-ui-button_1",
			});

			batch.addJson("levels", "./assets/json/levels.json", false);
		}
		return batch;
	}

	//==========================// Menu Assets //==========================//
	static get Menu(): LoadBatch {
		const batch = F84Game.Instance.loadBatches.get("menu");
		if (batch.assets.size == 0) {
			batch.addSounds("./assets/audio/sfx/", {
				// upgradeSFX: "mm-sfx-scratch-upgrade_1",
			});
			batch.addImages("./assets/images/level-select/ag-lumi-ski-lvl-", {
				lvlCorinne: "corinne",
			});

			batch.addImages("./assets/images/temp/", {
				levelSelectBtn: "level-select-button",
				levelSelectLocked: "level-select-locked",
			});

			batch.addImages("./assets/images/splash/ag-lumi-", {
				playBtn: "btn-play",
				resetBtn: "btn-reset",
				splashCharacter: "ski-splash-character",
				certificateButton: "ui-btn-certificates",
			});

			batch.addImages("./locale/images/" + F84Game.Instance.locale + "/", {
				splashLogo: "ag-lumi-ski-logo-3",
			});
		}
		return batch;
	}

	//==========================// Standard Gameplay Assets //==========================//
	static Gameplay(scene: LoaderScene): LoadBatch {
		const batch = F84Game.Instance.loadBatches.get("gameplay");
		if (batch.assets.size == 0) {
			batch.addImages("./assets/images/environment/ag-lumi-", {
				topHill: "gp-tophill",
				mainHill: "gp-mainhill",
				bottomHill: "gp-bottomhill",
			});

			batch.addImages("./assets/images/game/ag-lumi-gp-", {
				obstacle1: "hazard-boulder",
				obstacle2: "hazard-log",
				obstacle3: "hazard-stump",
				obstacle4: "hazard-tree",
				flagGreenCircle: "flag-beginner",
				flagBlueSquare: "flag-moderate",
				flagBlackDiamond: "flag-blackdiamond",
				flagDoubleBlackDiamond: "flag-doubleblackdiamond",
				flagBackcountry: "flag-backwoods",
				//flag: "flag",
				finishFlag: "flag-finish",
				finishLine: "finishline",
				ramp: "ramp",
				rampArrow: "ramp-arrow",
				pickupStar: "pickup-star",
				sparkle1: "pickup-sparkle1",
				sparkle2: "pickup-sparkle2",

				badBubble: "bubble-bad",
				goodBubble: "bubble-good",

				meterBG: "meter",
				meterBar: "meterbar",

				skiFlurry: "flurry",
				shadow: "shadow",
				skiSnow1: "skisnow1",
				skiSnow2: "skisnow2",
				skiSnow3: "skisnow3",
				skiSparkle1: "skisparkle1",
				skiSparkle2: "skisparkle2",

				finishCheers: "cheerteam-finish",
				swipeArrow: "swipe-arrow",
			});

			batch.addImages("./assets/images/ui/ag-lumi-ui-", {
				pauseBtn: "btn-pause",
				progressCircleEnd: "tracker-circle-end",
				progressCircleMid: "tracker-circle-mid",
				progressMarker: "tracker-head",
				progressBar: "tracker-line",
				progressBG: "tracker",
				totalScoreBG: "popup-totalscore",

				helpBtn: "btn-help",
				nextBtn: "btn-resume",

				widescreenBorder: "widescreen-border",
			});

			batch.addImages("./assets/images/recap/ag-lumi-ui-", {
				popupScore: "popup-score",
				smallTextHeader: "popup-smallheader",
				popupNewBest: "popup-newbest",
				medalRays: "popup-rays",
				medalRayGlow: "popup-raysglow",
				recapCorinne: "recap-corinne",

				GreenCircleRecapIcon: "recap-icon-beginner",
				BlueSquareRecapIcon: "recap-icon-moderate",
				BlackDiamondRecapIcon: "recap-icon-blackdi",
				DoubleBlackDiamondRecapIcon: "recap-icon-dblblackdi",
				BackcountryRecapIcon: "recap-icon-backwoods",

				replayBtn: "btn-replay",
			});

			batch.addImages("./assets/images/help/ag-lumi-", {
				helpImage1: "ski-help-img1",
				helpImage2: "ski-help-img2",
				helpImage3: "ski-help-img3",
				helpImage4: "ski-help-img4",
				helpImage5: "ski-help-img5",
				smallTextBG: "ski-help-smalltextbacker",
				longTextBG: "ski-help-longtextbacker",
				numberBG: "help-numberbase",
			});

			batch.addImages("./assets/images/help/", {
				helpHand: "hand",
			});

			batch.addSounds("./assets/audio/sfx/", {
				flagCollectSFX: "ski-flag-collect_1",
				hitObstacleSFX: "ski-hit-obstacle",
				levelCompleteSFX: "ski-level-complete",
				performTrickSFX: "ski-perform-trick",
				rampSFX: "ski-ramp",
				ambienceSFX: "ski-ambience",
			});

			const chunks = scene.cache.json.get("chunks") as { [key: string]: string[] };
			for (const category in chunks) {
				for (const chunk of chunks[category]) {
					batch.addJson(chunk, "./assets/json/chunks/" + chunk + ".json", false);
				}
			}

			batch.addSpine("player", "./assets/spine/character/", "skier_character", false);

			// batch.addAtlas("molly-walk-up", "./assets/images/game/molly/", "molly-walk-up", "molly-walk-up", false);
			// batch.addJson("dialogues", "./assets/json/dialogues.json", false);
		}
		return batch;
	}

	static loadLevelAssets(scene: LoaderScene, levelName: string): LoadBatch {
		const batch = F84Game.Instance.loadBatches.get("levelAssets-" + levelName) as LoadBatch;
		if (levelName.includes("GreenCircle") || levelName.includes("BlueSquare")) {
			batch.addImages("./assets/images/environment/level-1-2/", {
				cloud1: "ag-lumi-gp-bg-dawn-cloud1",
				cloud2: "ag-lumi-gp-bg-dawn-cloud2",
				tree1: "ag-lumi-gp-bg-dawn-trees1",
				tree2: "ag-lumi-gp-bg-dawn-trees2",
				tree3: "ag-lumi-gp-bg-dawn-trees3",
				tree4: "ag-lumi-gp-bg-dawn-trees4",
				mountain: "ag-lumi-gp-bg-dawn-mountains",
				sky: "ag-lumi-gp-bg-dawn-sky",
			});
		}

		if (levelName.includes("BlackDiamond") || levelName.includes("DoubleBlackDiamond")) {
			batch.addImages("./assets/images/environment/level-3-4/", {
				cloud1: "ag-lumi-gp-bg-day-cloud1",
				cloud2: "ag-lumi-gp-bg-day-cloud2",
				tree1: "ag-lumi-gp-bg-day-trees1",
				tree2: "ag-lumi-gp-bg-day-trees2",
				tree3: "ag-lumi-gp-bg-day-trees3",
				tree4: "ag-lumi-gp-bg-trees4",
				tree5: "ag-lumi-gp-bg-trees5",
				mountain: "ag-lumi-gp-bg-day-mountains",
				sky: "ag-lumi-gp-bg-day-sky",
			});
		}

		if (levelName.includes("Backcountry")) {
			batch.addImages("./assets/images/environment/level-5/", {
				cloud1: "ag-lumi-gp-bg-snow-cloud1",
				cloud2: "ag-lumi-gp-bg-snow-cloud2",
				tree1: "ag-lumi-gp-bg-snow-trees1",
				tree2: "ag-lumi-gp-bg-snow-trees2",
				tree3: "ag-lumi-gp-bg-snow-trees3",
				tree4: "ag-lumi-gp-bg-snow-trees4",
				tree5: "ag-lumi-gp-bg-snow-trees5",
				mountain: "ag-lumi-gp-bg-snow-mountains",
				sky: "ag-lumi-gp-bg-snow-sky",
			});
		}

		return batch;
	}

	static loadTilesetImages(batch: LoadBatch, tileset: Tileset, path: string): void {
		for (const tile of tileset.tiles) {
			if (tile.properties) {
				const dontLoadProperty = tile.properties.find((p) => p.name == "dontLoad") as MapObjectProperty;
				if (dontLoadProperty && dontLoadProperty.value == true) continue;
			}
			const split = tile.image.split("/");
			const filename = split[split.length - 1];
			batch.addImage(filename, path + filename);
		}
	}
}
